import { getFileDownloadUrl } from "../../utils/deliveryApi";
import { useTranslation } from "../../i18n";

function MobileBatchSavePanel({ files, open, onClose }) {
    const { t } = useTranslation();

    if (!open || !files?.length) {
        return null;
    }

    return (
        <div
            className="delivery-batch-save"
            role="dialog"
            aria-modal="true"
            aria-label={t("delivery.actions.mobileBatchSaveTitle")}
        >
            <div className="delivery-batch-save__header">
                <div>
                    <h2 className="delivery-batch-save__title">
                        {t("delivery.actions.mobileBatchSaveTitle")}
                    </h2>
                    <p className="delivery-batch-save__intro">
                        {t("delivery.actions.mobileBatchSaveIntro")}
                    </p>
                    <p className="delivery-batch-save__count">
                        {files.length} {t("delivery.actions.selectedPhotosUnit")}
                    </p>
                </div>
                <button
                    type="button"
                    className="delivery-batch-save__close"
                    onClick={onClose}
                    aria-label={t("delivery.actions.close")}
                >
                    ×
                </button>
            </div>

            <div className="delivery-batch-save__list">
                {files.map((file, index) => {
                    const url = getFileDownloadUrl(file);
                    if (!url) {
                        return null;
                    }

                    return (
                        <article key={file.id} className="delivery-batch-save__item">
                            <p className="delivery-batch-save__item-meta">
                                {index + 1} / {files.length} · {file.name}
                            </p>
                            <div className="delivery-batch-save__image-wrap">
                                <img
                                    src={url}
                                    alt=""
                                    draggable={false}
                                    loading="eager"
                                    decoding="async"
                                    className="delivery-batch-save__image"
                                />
                            </div>
                            <p className="delivery-batch-save__item-hint">
                                {t("delivery.actions.mobileSaveHint")}
                            </p>
                        </article>
                    );
                })}
            </div>
        </div>
    );
}

export default MobileBatchSavePanel;
